import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02805575"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logistics" }
const _hoisted_2 = { class: "logistics_info" }
const _hoisted_3 = { class: "logistics_info_detail" }
const _hoisted_4 = {
  key: 0,
  class: "info_order"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Order No:   ")
const _hoisted_6 = {
  key: 1,
  class: "info_order"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Tracking Number:   ")
const _hoisted_8 = {
  key: 2,
  class: "info_order"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Estimated Arrival Date:   ")
const _hoisted_10 = { class: "course" }
const _hoisted_11 = { class: "course_item" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "course_item" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "course_item"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "course_item"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "course_item" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "course_text" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ordered", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "In Transit", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Signed", -1))
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "logistics_node" }
const _hoisted_34 = { class: "logistics_node_content" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "city" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isShowHeader)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: "Package Tracking"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.waybill, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        style: _normalizeStyle($setup.waybill.length>=2?'marginTop:.278rem':'')
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ($setup.logistics.logisticsOrderNo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("span", null, _toDisplayString($setup.logistics.logisticsOrderNo), 1)
                ]))
              : _createCommentVNode("", true),
            (item.waybillNo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("span", null, _toDisplayString(item.waybillNo), 1)
                ]))
              : _createCommentVNode("", true),
            (item.estimatedArrivalDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", null, _toDisplayString(item.estimatedArrivalDate), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (item.waybillStatusCode >= 100)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_order_normal@2x.png'.webpFilters(),
                      alt: ""
                    }, null, 8, _hoisted_12))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_order_disable@2x.png'.webpFilters(),
                      alt: ""
                    }, null, 8, _hoisted_13)),
                _createElementVNode("i", {
                  class: _normalizeClass({'dashed':!(item.waybillStatusCode >= 200) ,'active': item.waybillStatusCode >= 200})
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_14, [
                (item.waybillStatusCode >= 200)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_delivery_normal@2x.png'.webpFilters(),
                      alt: ""
                    }, null, 8, _hoisted_15))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_delivery_disable@2x.png'.webpFilters(),
                      alt: ""
                    }, null, 8, _hoisted_16)),
                _createElementVNode("i", {
                  class: _normalizeClass({'dashed':!(item.waybillStatusCode >= 300),'active':item.waybillStatusCode >= 300 })
                }, null, 2)
              ]),
              (item.selfPick)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (item.waybillStatusCode >= 400)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_Pickup_Station@2x.png'.webpFilters(),
                          alt: ""
                        }, null, 8, _hoisted_18))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_Pickup_Station_disable@2x.png'.webpFilters(),
                          alt: ""
                        }, null, 8, _hoisted_19)),
                    _createElementVNode("i", {
                      class: _normalizeClass({'dashed':!(item.waybillStatusCode >= 500),'active':item.waybillStatusCode >= 500 })
                    }, null, 2)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (item.waybillStatusCode >= 300)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_transit_normal@2x.png'.webpFilters(),
                          alt: ""
                        }, null, 8, _hoisted_21))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_transit_disable@2x.png'.webpFilters(),
                          alt: ""
                        }, null, 8, _hoisted_22)),
                    _createElementVNode("i", {
                      class: _normalizeClass({'dashed':!(item.waybillStatusCode >= 500),'active':item.waybillStatusCode >= 500})
                    }, null, 2)
                  ])),
              _createElementVNode("div", _hoisted_23, [
                (item.waybillStatusCode >= 500)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_sign_normal@2x.png'.webpFilters(),
                      alt: ""
                    }, null, 8, _hoisted_24))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: 'http://image.kilimall.com/kenya/new_wap/logistics/icon_sign_disable@2x.png'.webpFilters(),
                      alt: ""
                    }, null, 8, _hoisted_25))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _hoisted_28,
              (item.selfPick)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Pickup Station"))
                : (_openBlock(), _createElementBlock("span", _hoisted_30, "Out for Delivery")),
              _hoisted_31
            ]),
            _createElementVNode("div", {
              class: "btn_more",
              onClick: ($event: any) => ($setup.openMore(i)),
              style: _normalizeStyle($setup.selectFlag?'color:#4B90E1;textDecoration: underline;':'')
            }, [
              _createTextVNode(_toDisplayString($setup.selectFlag?' Roll Up':'More') + " ", 1),
              _createElementVNode("i", {
                style: _normalizeStyle($setup.selectFlag&&$setup.more_index == i?'transform: rotateZ(-90deg);':'transform: rotateZ(90deg);')
              }, null, 4)
            ], 12, _hoisted_32)
          ])
        ]),
        _createVNode(_Transition, { name: "logisticsNode" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.nodeInfos, (item1) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "big_node",
                    key: item1.nodeName
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass({'grayIcon':item1.nodeCode==100,'grayIcon1':item1.nodeCode==200,'grayIcon2':item1.nodeCode==300,'grayIcon3':item1.nodeCode==400})
                    }, null, 2),
                    (item.waybillStatusCode === item1.nodeCode)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass({'icon':item.waybillStatusCode == 100,'icon1':item.waybillStatusCode == 200,'icon2':item.waybillStatusCode == 300,'icon3':item.waybillStatusCode  == 400,'icon4':item.waybillStatusCode  == 500})
                        }, null, 2))
                      : _createCommentVNode("", true),
                    (!item1.trackingInfo.length == 0)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_35, [
                          _createTextVNode(_toDisplayString(item1.nodeName) + " ", 1),
                          (item1.nodeCode == 400 &&item1.networkId)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                onClick: ($event: any) => ($setup.goPickup(item1.networkId))
                              }, "Map & Contacts", 8, _hoisted_36))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.trackingInfo, (item2, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "small_nodes",
                        key: i
                      }, [
                        _hoisted_37,
                        _createElementVNode("span", null, _toDisplayString(item2.tracking), 1),
                        (item2.trackingTime > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                              _createElementVNode("span", null, _toDisplayString($setup.dateFormat(item2.trackingTime*1000)), 1),
                              _createElementVNode("span", _hoisted_39, _toDisplayString(item2.city) + "," + _toDisplayString(item2.country), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ], 512), [
              [_vShow, $setup.selectFlag&&$setup.more_index == i]
            ])
          ]),
          _: 2
        }, 1024)
      ], 4))
    }), 128))
  ]))
}